<template>
  <div>
<!--    <div class="crumbs">-->
<!--      <el-breadcrumb separator="/">-->
<!--        <el-breadcrumb-item>巡检任务分配</el-breadcrumb-item>-->
<!--      </el-breadcrumb>-->
<!--    </div>-->
    <div style="margin-top: 20px">
      <span>设备名称:<el-input v-model="Name" placeholder="设备名称" clearable style="width: 180px" clearable></el-input></span>
      <span style="margin-left: 20px">区域:
        <el-cascader placeholder="请选择区域" multiple v-model="Area" :props="{ checkStrictly: true }"
                     :options="AreaList.result.areaList" clearable
        >

        </el-cascader>
<!--        <el-select v-model="Area" clearable>-->
<!--          <el-option v-for="item in AreaList.result.areaList" :label="item.label" :value="item.value"></el-option>-->
<!--        </el-select>-->
      </span>
      <span style="margin-left: 20px">设备类型:<el-select v-model="Type" placeholder="设备类型" clearable>
        <el-option v-for="item in alarmtype"
                   :label="item"
                   :value="item"
        >
        </el-option>
      </el-select></span>
      <span style="margin-left: 20px">是否在线:<el-select v-model="isState" placeholder="是否在线" clearable>
        <el-option
          v-for="item in state"
          :key="item"
          :lable="item"
          :value="item"
        >
        </el-option>
      </el-select></span>
      <span style="margin-left: 20px"><el-button type="primary" @click="getPointState()">查询</el-button></span>
      <span style="margin-left: 20px"><el-button type="info" @click="reset">重置</el-button></span>
    </div>
    <div style="margin-top: 30px">
      <el-table
        ref="deviceStatement"
        :data="stateTable"
        style="width:100%"
        tooltip-effect="dark"
        :height="tableHeight"
        :cell-style="cellStyle"
      >
        <el-table-column
          prop="alarmPointName"
          label="设备名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="alarmPointType"
          label="设备类型"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="areaName"
          label="设备区域"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="onLine"
          label="在线"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="voltage1"
          label="设备供电"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="voltage2"
          label="设备开机"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="voltage3"
          label="警报供电"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sound"
          label="声压"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @current-change="getPointState(1)"
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="TotalCount*10"
          :current-page.sync="GetStateList.params.pageNumber"
        >
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'stateManagement',
    data(){
      return{
        Name:'',
        Area:'',
        Type:'',
        isState:'',
        currentPage:1,
        TotalCount:'',//总页数
        GetAreaInfoList:{//获取区域列表
          "version":1,
          "method":"area.GetAreaList",
          "params":null,
          "token":"#",
          "id":0
        },
        AreaList:{//区域列表
          "version": 1,
          "result":{
            "areaList": [
              {
                "areaId": "",
                "label": "",
                "childList":[],
              },
            ]
          },
          "id": 0
        },
        alarmtype:['电声警报器','电动警报器','一体机','多媒体','其他'],
        state:['在线','不在线'],
        tableHeight:530,
        GetStateList:{
          "version": 1,
          "method": "state.GetPointStateList",
          "params": {
              "pageNumber":1,
              "alarmPointName":"",
              "areaId":"",
              "alarmPointType":"",
              "onLine":"",
              "voltage1":"",
              "voltage2":"",
              "voltage3":"",
          },
          "token":"#",
          "id": 0
    },
        stateTable:[
        ]
      }
    },
    methods:{
      getAreaList(){//获取区域列表
        this.GetAreaInfoList.token = this.$store.state.token;
        this.$axios.post(this.$mainUrl,this.GetAreaInfoList).then(res =>{
          if(res.data.hasOwnProperty('result')){
            let areaList = JSON.stringify(res.data);
            areaList  = areaList.replace(/childList/g, 'children');
            areaList  = areaList.replace(/areaName/g, 'label');
            areaList  = areaList.replace(/areaId/g, 'value');
            areaList = JSON.parse(areaList);
            this.AreaList = areaList;
          }
        })
      },
      getPointState(val){//获取状态设备
        this.GetStateList.params.alarmPointName = this.Name;
        this.GetStateList.params.alarmPointType = this.Type;
        if(this.Area.length == 1){
          this.GetStateList.params.areaId = this.Area[0];
        }
        if(this.Area.length == 2){
          this.GetStateList.params.areaId = this.Area[1];
        }
        if(val == 2){
          this.GetStateList.params.pageNumber = 1;
        }
        if(this.isState == '在线'){
          this.GetStateList.params.onLine = true;
        }else if(this.isState == '不在线'){
          this.GetStateList.params.onLine = false;
        }else{
          this.GetStateList.params.onLine = null;
        }
        //this.GetStateList.params.onLine = this.isState;
        //this.GetStateList.params.pageNumber = 1;
        for (let val in this.GetStateList.params){
          if(this.GetStateList.params[val] === ""){
            this.GetStateList.params[val] = null;
          }
        };
        this.$axios.post(this.$mainUrl,this.GetStateList).then(res=>{
          if(res.data.hasOwnProperty('result')) {
            if(res.data.result.pointStateList.length == undefined){
              this.stateTable = [];
            }else{
              for (let i = 0; i < res.data.result.pointStateList.length; i++) {
                if (res.data.result.pointStateList[i].onLine == true) {
                  res.data.result.pointStateList[i].onLine = "在线"
                } else {
                  res.data.result.pointStateList[i].onLine = "不在线"
                }
                if (res.data.result.pointStateList[i].voltage1 == true) {
                  res.data.result.pointStateList[i].voltage1 = "已加电"
                } else {
                  res.data.result.pointStateList[i].voltage1 = "未加电"
                }
                if (res.data.result.pointStateList[i].voltage2 == true) {
                  res.data.result.pointStateList[i].voltage2 = "已加电"
                } else {
                  res.data.result.pointStateList[i].voltage2 = "未加电"
                }
                if (res.data.result.pointStateList[i].voltage3 == true) {
                  res.data.result.pointStateList[i].voltage3 = "已加电"
                } else {
                  res.data.result.pointStateList[i].voltage3 = "未加电"
                }
                if (res.data.result.pointStateList[i].sound != false) {
                  res.data.result.pointStateList[i].sound = res.data.result.pointStateList[i].sound + "DB"
                } else {
                  res.data.result.pointStateList[i].sound = "0DB"
                }
              }
              this.TotalCount = res.data.result.page;
              this.stateTable = res.data.result.pointStateList;
            }




          }
        })
      },
      // search(){//查询设备状态
      //   this.GetStateList.params.alarmPointName = this.Name;
      //   this.GetStateList.params.alarmPointType = this.Type;
      //   if(this.Area.length>1){
      //     this.Area = this.Area[1].substring(0,5);
      //     this.GetStateList.params.areaId = this.Area.toString()
      //   }else if(this.Area.length==1){
      //     this.GetStateList.params.areaId = this.Area.toString()
      //   }else{
      //     this.GetStateList.params.areaId = null;
      //   }
      //   //this.GetStateList.params.onLine = this.isState;
      //   this.GetStateList.params.pageNumber = 1;
      //   for (let val in this.GetStateList.params){
      //     if(this.GetStateList.params[val] === ""){
      //       this.GetStateList.params[val] = null;
      //     }
      //   };
      //   this.$axios.post(this.$mainUrl,this.GetStateList).then(res=>{
      //     if(res.data.hasOwnProperty('result')) {
      //
      //       for (let i = 0; i < res.data.result.pointStateList.length; i++) {
      //         if (res.data.result.pointStateList[i].onLine == true) {
      //           res.data.result.pointStateList[i].onLine = "在线"
      //         } else {
      //           res.data.result.pointStateList[i].onLine = "不在线"
      //         }
      //         if (res.data.result.pointStateList[i].voltage1 == true) {
      //           res.data.result.pointStateList[i].voltage1 = "已加电"
      //         } else {
      //           res.data.result.pointStateList[i].voltage1 = "未加电"
      //         }
      //         if (res.data.result.pointStateList[i].voltage2 == true) {
      //           res.data.result.pointStateList[i].voltage2 = "已加电"
      //         } else {
      //           res.data.result.pointStateList[i].voltage2 = "未加电"
      //         }
      //         if (res.data.result.pointStateList[i].voltage3 == true) {
      //           res.data.result.pointStateList[i].voltage3 = "已加电"
      //         } else {
      //           res.data.result.pointStateList[i].voltage3 = "未加电"
      //         }
      //         if (res.data.result.pointStateList[i].sound != false) {
      //           res.data.result.pointStateList[i].sound = res.data.result.pointStateList[i].sound + "db"
      //         } else {
      //           res.data.result.pointStateList[i].sound = "0db"
      //         }
      //         this.stateTable = res.data.result.pointStateList;
      //         alert(this.stateTable);
      //         this.TotalCount = res.data.result.page;
      //       }
      //     }
      //   })
      // },
        reset(){//重置
          this.Name = '';
          this.Type = '';
          this.Area = '';
          this.isState = ''
        },

      cellStyle(row,column,rowIndex,columnIndex){
        if(row.column.label==="在线"&& row.row.onLine==="不在线"){
          return 'color:red'
      }
    },
    },
      mounted () {
        this.getAreaList();
        this.getPointState(1);
      }
  }
</script>

<style scoped>

</style>
